import { useCallback, useEffect, useRef } from 'react';

export const useLatestAsyncRequest = () => {
  const isMountedRef = useRef(true);
  const requestIdRef = useRef(0);

  useEffect(() => {
    isMountedRef.current = true;

    return () => {
      isMountedRef.current = false;
      requestIdRef.current += 1;
    };
  }, []);

  const beginRequest = useCallback(() => {
    const requestId = requestIdRef.current + 1;
    requestIdRef.current = requestId;
    return requestId;
  }, []);

  const isCurrentRequest = useCallback((requestId) => (
    isMountedRef.current && requestId === requestIdRef.current
  ), []);

  const isMounted = useCallback(() => isMountedRef.current, []);

  return {
    beginRequest,
    isCurrentRequest,
    isMounted
  };
};
